import { render, staticRenderFns } from "./sports.vue?vue&type=template&id=12e3e12e&"
import script from "./sports.vue?vue&type=script&lang=js&"
export * from "./sports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports